import { isPublicForm } from 'apps/web_forms/api/api';

// Relative path where the app is
const webFormsPath = window.location.pathname.match(/\/organizations\/\d+\/web_forms/g);
let basePath = webFormsPath ? webFormsPath[0] : '/';
const orgPath = window.location.pathname.match(/\/organizations\/\d+/g);
let organizationPath = orgPath ? orgPath[0] : '/';
export const APP_BASE_NAME = basePath;
export const API_BASE_PATH = basePath;

export let ALWAYS_FETCH_FORM = false;

export const toggleAlwaysFetchForm = (value) => ALWAYS_FETCH_FORM = value;

export const APP_ROUTES = {
  mainPage: '/',
  formsPage: '/forms',
  formPage: '/form/:id',
  submissionPage: '/forms/:id/submissions/:submissionId',
  submissionSuccessPage: '/submission_success',
  webstorePage: (id) => `${organizationPath}/web_stores/${id}`,
  unauthenticatedFormPage: '/shared_form/:id',
  getFormPageById: (id, queryParams = '') => `/form/${id}${queryParams}`,
  dispatches: '/dispatches',
  dispatchesDetails: '/dispatches/:type',
  getDispatchesDetails: (dispatchType) => `/dispatches/${dispatchType}`,
  draftsPage: '/drafts',
  errorPage: '/error/:errorId',
  sharedFormErrorPage: '/shared_form/error/:errorId',
  getErrorPageByCode: (code) =>
    `${isPublicForm() ? '/shared_form' : ''}/error/${code}`,
};

export const DEVICES_SIZES = {
  tablet: '801px',
  desktop: '1281px',
};

export const INPUT_DEBOUNCE_MS = 0;

const fadedGrey = '#a7a7a7';
export const COLORS = {
  primary: '#05CD78',
  lighterPrimary: '#78bd18',
  darkerPrimary: '#00a861',
  // Secondary???
  titleGrey: '#333333',
  greyText: '#303030',
  lightgrey: '#dadada',
  lighterGrey: '#eeeeee',
  textColor: '#555555',
  grey: '#4C4C4C',
  borderGrey: '#dddddd',
  fadedGrey,
  secondaryBorderGrey: fadedGrey,
  green: '#20cd7c',
  darkGreen: '#19a563',
  inputBackgroundColor: '#f8f8f8',
  disabledInputBackgroundColor: '#a4a4a4',
  readOnlyInputBackgroundColor: '#dddddd',
  inputGroupsBackgroundColor: '#e6e6e6',
  borderBooleanRadio: '#a4a4a4',
  borderCheckBox: '#999999',
  booleanInputBackgroundColor: '#d9d9d9',
  readOnlyBooleanInputBackgroundColor: '#999999',
  red: '#d54347',
  completedCircleColor: '#77BB1F',
  dispatchDisabledColor: '#A5A5A5',
  yellow: '#F08B16',
};

export const FONT_WEIGHT = {
  bold: 800,
};

const UpdateHighlightBorderWidth = '2px';

export const STYLES = {
  ErrorHighlight: `1px solid ${COLORS.red}`,
  UpdateHighlightBorderWidth: UpdateHighlightBorderWidth,
  UpdateHighlight: `${UpdateHighlightBorderWidth} solid ${COLORS.yellow}`,
};

export const GOOGLE_MAPS_API_KEY = window.gmapsKey;
export const GOOGLE_MAPS_DOMAIN = 'https://www.google.com/';
window.gmapsKey = undefined;
export const HIDE_DRAFTS = window.hideDrafts; // TODO remove when drafts published
export const DEVICE_IDENTIFIER = window.deviceIdentifier;

export const LOCATION_CONFIG = {
  LOCATION_LOAD_TIME_LIMIT: 5000,
  DEFAULT_LOCATION_MESSAGE: 'Improving accuracy... ',
  defaultLat: 35.8189472,
  defaultLng: -78.6762791,
};

export const expressionNames = [
  'visible_expr',
  'required_expr',
  'readonly_expr',
  'calculate_expr',
  'validate_expr',
  'options_filter_expr',
];

export const ACCEPTED_TYPES_FOR_GENERATED_PARAM = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.sql.table',
  'application/vnd.device-magic.list',
  'application/vnd.device-magic.webstore',
  'application/vnd.google.sheet',
]

export const modalMessages = {
  submitSuccess: {
    main: 'Form submitted successfully',
  },
  formActionSucess: {
    main: 'Form {action} successfully',
  },
  submitFail: {
    main: 'There are errors in the form',
    tip: 'Please fix them before submitting',
  },
  deleteSuccess: {
    main: 'Deleted successfully',
  },
  draftCopySuccess: {
    main: 'Draft copied successfully',
  },
  draftReassignSuccess: {
    main: 'Draft reassigned successfully',
  },
  saveDraft: {
    main: 'Save Draft',
    tip: 'You can optionally add a description for the saved form below',
  },
  copyDraft: {
    main: 'Copy Draft',
    tip: 'You can optionally provide a new description for the draft copy',
  },
  reassignDraft: {
    main: 'Reassign Draft',
    tip: 'You can reassign a draft to a person or device',
  },
  multiDispatchFail: {
    main: 'Failed to save or submit dispatch',
    tip: 'Dispatches may only be saved or submitted once',
  },
};

export const dispatchTypes = {
  GEO_LOCATED: 'Geolocated',
  GEO_FENCED: 'Geofenced',
  REGULAR: 'Regular',
};

// Todo: Remove this check when hide drafs feature flag is removed
export const LEAVE_WARNING_MSG = HIDE_DRAFTS
  ? 'Going back will delete all captured data on this form. Are you sure you want to leave the form?'
  : 'Are you sure? To avoid data lost use draft button.';

export const ERROR_LOADING_DISPATCHES = 'Error loading dispatches';

export const FEET_TO_METERS = 3.2808;

export const LATEST = 'latest';

export const ORIGINS = {
  Form: 'form', // default
  Geolocated: 'geolocated',
  Geofenced: 'geofenced',
  Dispatch: 'dispatch',
  Draft: 'draft',
  Submission: 'submission',
};

export const STRINGS = {
  improvedPerf: 'Improved Performance',
  legacy: 'Legacy',
  toggleText: 'Toggle between high performance and legacy mode!',
};

export const EMPTY_DATETIME_VALUE = 'EMPTY_DATETIME_VALUE';

/** IDs */

const FormsIdPrefix = 'Forms';

const FormsIds = {
  MainFormList: `${FormsIdPrefix}-main-form-list`,
};

const FormIdPrefix = 'Form';

const FormIds = {
  FormSubmitFailModal: `${FormIdPrefix}-submit-fail-modal`,
  MultiDispatchFailModal: `${FormIdPrefix}-multi-dispatch-fail-modal`,
  MultiDispatchFailModalOkButton: `${FormIdPrefix}-multi-dispatch-fail-modal-ok-button`,
  UpdateResourceConfirmationButton: `${FormIdPrefix}-update-resource-conf-button`,
  UpdateResourceCancelButton: `${FormIdPrefix}-update-resource-cancel-button`,
  UpdateResourcesButton: `${FormIdPrefix}-update-resources-button`,
  UpdateResourceConfirmationModal: `${FormIdPrefix}-update-resource-conf-modal`,
};

const DraftsIdPrefix = 'Drafts';

const DraftsIds = {
  DeleteConfirmationButton: `${DraftsIdPrefix}-delete-confirmation-button`,
  CancelButton: `${DraftsIdPrefix}-cancel-button`,
  OpenButton: `${DraftsIdPrefix}-open-button`,
  CopyButton: `${DraftsIdPrefix}-copy-button`,
  DeleteButton: `${DraftsIdPrefix}-delete-button`,
  ReassignButton: `${DraftsIdPrefix}-reassign-button`,
};

const DispatchesIdPrefix = 'Dispatches';

const DispatchesIds = {
  MainSection: 'DispatchesFormList',
  GeolocatedSection: 'GeolocatedDispatchesFormList',
  GeofencedSection: 'GeofencedDispatchesFormList',
  GeolocatedDetailsList: `${DispatchesIdPrefix}-geolocated-details-list`,
  GeofencedDetailsList: `${DispatchesIdPrefix}-geofenced-details-list`,
  OpenDispatchButton: `${DispatchesIdPrefix}-open-dispatch-button`,
  OpenGeolocatedDispatchButton: `${DispatchesIdPrefix}-open-geolocated-dispatch-button`,
  GeolocatedDirectionsButton: `${DispatchesIdPrefix}-geolocated-directions-button`,
  OpenGeofencedDispatchButton: `${DispatchesIdPrefix}-open-geofenced-dispatch-button`,
  GeofencedDirectionsButton: `${DispatchesIdPrefix}-geofenced-directions-button`,
};

const DispatchesDetailsIdPrefix = 'DispatchesDetails';

const DispatchesDetailsIds = {
  OpenButton: `${DispatchesDetailsIdPrefix}-open-button`,
  DirectionsButton: `${DispatchesDetailsIdPrefix}-directions-button`,
};

const MenuBadgesIdPrefix = 'MenuBadges';

const MenuBadgesIds = {
  DraftsBadge: `${MenuBadgesIdPrefix}-drafts-badge`,
  DispatchesBadge: `${MenuBadgesIdPrefix}-dispatches-badge`,
};

const SaveDraftModalIdPrefix = 'SaveDraftModal';

const SaveDraftModalIds = {
  SaveDraftModal: SaveDraftModalIdPrefix,
  CancelButton: `${SaveDraftModalIdPrefix}-cancel-button`,
  SaveButton: `${SaveDraftModalIdPrefix}-save-button`,
};

const ReassignDraftModalIdPrefix = 'ReassignDraftModal';

const ReassignDraftModalIds = {
  ReassignDraftModal: ReassignDraftModalIdPrefix,
  CancelButton: `${ReassignDraftModalIdPrefix}-cancel-button`,
  SaveButton: `${ReassignDraftModalIdPrefix}-save-button`,
};

const NotificationBarPrefix = 'NotificationBar';

const NotificationBarIds = {
  InfoBadge: `${NotificationBarPrefix}-info-badge`,
};

export const NOTIFICATION_BOX_TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
};

export const ids = {
  FormIds,
  FormsIds,
  DraftsIds,
  DispatchesIds,
  DispatchesDetailsIds,
  MenuBadgesIds,
  SaveDraftModalIds,
  ReassignDraftModalIds,
  NotificationBarIds,
};

export const FormTypes = {
  FORM: "FORM",
  DRAFT: "DRAFT",
  DISPATCH: "DISPATCH",
  DISPATCH_DRAFT: "DISPATCH_DRAFT",
  SUBMISSION: "SUBMISSION",
  PUBLIC_FORM: "PUBLIC_FORM",
}

export const ModalTypes = { 
  RESOURCE_LOADING_MODAL: 'RESOURCE_LOADING_MODAL',
  SUBMIT_FAIL_MODAL: 'SUBMIT_FAIL_MODAL',
  RANGE_FAILURE_MODAL: 'RANGE_FAILURE_MODAL',
  LOCATION_FAILURE_MODAL: 'LOCATION_FAILURE_MODAL',
  DRAFT_MODAL: 'DRAFT_MODAL',
  MULTI_DISPATCH_FAIL_MODAL: 'MULTI_DISPATCH_FAIL_MODAL',
  RESOURCE_UPDATE_CONFIRMATION_MODAL: 'RESOURCE_UPDATE_CONFIRMATION_MODAL',
  DRAFT_REASSIGNMENT_MODAL: "DRAFT_REASSIGNMENT_MODAL",
  DRAFT_REASSIGNMENT_SUCCESS_MODAL: "DRAFT_REASSIGNMENT_SUCCESS_MODAL",
  COPY_DRAFT_MODAL: "COPY_DRAFT_MODAL",
  COPY_DRAFT_SUCCESS_MODAL: "COPY_DRAFT_SUCCESS_MODAL",
  DELETE_DRAFT_MODAL: "DELETE_DRAFT_MODAL",
  DELETE_SUCCESS_MODAL: "DELETE_SUCCESS_MODAL",
  EXIT_PAGE_MODAL: "EXIT_PAGE_MODAL",
}

export const SUBMMISSION_TYPE = {
  DRAFT: 'draft',
  SUBMISSION: 'submission',
  FORM: 'form',
  DISPATCH: 'dispatch',
}

export const MODAL_TEST_IDS = {
  LOCATION_FAILURE_MODAL: 'LocationFailureModal',
  RANGE_FAILURE_MODAL: 'RangeFailureModal',
  RESOURCE_LOADING_MODAL: 'ResourceLoadingModal',
}